export default {
  name: 'vx-add-product-to-list',
  components: {},
  props: {
   /**
   * Labels, button and caption texts
   */
    i18n: {
      type: Object,
    },
  },
  data() {
    return {
      productNames: '',
    };
  },
  computed: {},
  created() {
    /**
     * This event listener helps in closing the popup incase the user clicks on any other part of the screen.
     */ 
    window.addEventListener('click', () => {
      this.$emit('closeAddProductToList');
    });
  },
  mounted() {},
  methods: {
     /**
     * This function emits an event and data to add products to the list ,it gets handled in vx-list-details. 
     */ 
    handleAddProductsToList() {
      this.$emit('addProductsToList', this.productNames);
    },
    /**
     * This function emits an event to close the popup. It gets handled in vx-list-details. 
     */ 
    closeAddProductToList() {
      this.$emit('closeAddProductToList');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/manage-profile-shopping-lists/vx-add-product-to-list/vx-add-product-to-list.js